"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDropdownHelper = void 0;
var BcDropdownHelper = (function () {
    function BcDropdownHelper() {
    }
    BcDropdownHelper.prototype.getProperty = function (obj, properties, defaultValue) {
        var property = null;
        if (properties.length > 0 && properties[0] in obj) {
            var obtTemp = obj[properties[0]];
            if (properties.length - 1 > 0) {
                property = this.getProperty(obtTemp, properties.slice(1, properties.length), defaultValue);
            }
            else {
                property = obtTemp;
            }
        }
        else {
            if (defaultValue) {
                property = defaultValue;
            }
        }
        return property;
    };
    BcDropdownHelper.prototype.isNullOrUndefined = function (property) {
        if (property === null || property === undefined) {
            return true;
        }
        return false;
    };
    return BcDropdownHelper;
}());
exports.BcDropdownHelper = BcDropdownHelper;
